import { Component, Input } from '@angular/core';
import { CurrentView } from '../../../api/models/user';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
  standalone: false,
})
export class LogoComponent {
  @Input() view?: CurrentView
}
